import { render } from "./DepositMaintenanceMalawi.vue?vue&type=template&id=4ed341aa&scoped=true"
import script from "./DepositMaintenanceMalawi.vue?vue&type=script&lang=js"
export * from "./DepositMaintenanceMalawi.vue?vue&type=script&lang=js"

import "./DepositMaintenanceMalawi.vue?vue&type=style&index=0&id=4ed341aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed341aa"]])

export default __exports__